var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_712_3632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9277 5.10905C3.90387 4.78831 4.14456 4.50898 4.46529 4.48515L9.88556 4.08236C10.2063 4.05852 10.4856 4.29921 10.5095 4.61995C10.5333 4.94068 10.2926 5.22001 9.97188 5.24385L4.5516 5.64664C4.23087 5.67047 3.95154 5.42978 3.9277 5.10905Z",
    fill: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63792 6.80812C4.31718 6.83196 4.07649 7.11129 4.10033 7.43202C4.12416 7.75276 4.40349 7.99344 4.72423 7.96961L8.59585 7.6819C8.91659 7.65807 9.15727 7.37874 9.13344 7.058C9.1096 6.73727 8.83027 6.49658 8.50954 6.52042L4.63792 6.80812Z",
    fill: "#101112"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84796 1.41662C1.81664 1.56757 0.292292 3.33666 0.443243 5.36798L1.01866 13.1112C1.13783 14.7149 2.53447 15.9183 4.13815 15.7992L12.6557 15.1662C13.4041 15.1106 13.9657 14.4588 13.9101 13.7104L13.047 2.09558C12.9914 1.34719 12.3396 0.785593 11.5912 0.841207L3.84796 1.41662ZM12.4177 9.34439L11.8855 2.18189C11.8775 2.07498 11.7844 1.99475 11.6775 2.00269L3.93428 2.57811C2.54442 2.68139 1.50145 3.89182 1.60473 5.28167L2.0075 10.7017C2.46572 10.3011 3.05291 10.0403 3.70659 9.99173L12.4177 9.34439ZM12.5041 10.5059L3.79291 11.1532C2.8307 11.2247 2.10864 12.0627 2.18014 13.0249C2.25165 13.9871 3.08963 14.7092 4.05184 14.6377L12.5694 14.0047C12.6763 13.9968 12.7566 13.9037 12.7486 13.7968L12.5041 10.5059Z",
    fill: "#101112"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_712_3632",
    x: -3.56714,
    y: -3.1626,
    width: 21.481,
    height: 22.9697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_712_3632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_712_3632",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.ee7cf2cf5e82de6611eb7d3ac68557bb.svg";
export { ForwardRef as ReactComponent };